import { render, staticRenderFns } from "./RegulatoryOrdinancePicker.vue?vue&type=template&id=7074a96c&"
import script from "./RegulatoryOrdinancePicker.vue?vue&type=script&lang=js&"
export * from "./RegulatoryOrdinancePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports